export const EMA_SEARCH_TIER = {
  EXACT: 'exact',
  LAST_NAME_DOB: 'last_name_dob',
  DOB_ONLY: 'dob_only',
};
export const PATIENT_SEARCH_CACHE_MS = 60 * 1000;

export const buildPatientSearchResult = (searchType, criteria, fetchedAt, data = {}) => ({
  patients: data.patients || [],
  searchTier: data.search_tier || null,
  searchType,
  criteria,
  fetchedAt,
});

export const patientSearchCriteriaMatch = (left, right) => {
  if (!left && !right) return true;
  if (!left || !right) return false;
  return ['firstName', 'middleName', 'lastName', 'dob'].every((key) => (
    String(left[key] || '').trim().toLowerCase()
      === String(right[key] || '').trim().toLowerCase()
  ));
};

export const patientSearchResultIsFresh = (result, now = Date.now()) => (
  Boolean(result?.fetchedAt) && now - result.fetchedAt <= PATIENT_SEARCH_CACHE_MS
);
